import { camelCase } from 'lodash-es';
export const getType = (object) => {
  return Object.prototype.toString.call(object);
};
export const isNull = (object) => {
  return object === null || object === undefined;
};
export const isNullOrEmpty = (object) => {
  if (isNull(object) || object === '' || JSON.stringify(object) === '{}') {
    return true;
  }
  const type = getType(object);
  if (type === '[object Array]' && object.length === 0) {
    return true;
  }
  if (type === '[object Object]' && Object.keys(object).length === 0) {
    return true;
  }
  if (type === '[object Set]' && object.size === 0) {
    return true;
  }
  return false;
};
export const isNoE = (object) => {
  if (isNull(object) || object === '' || JSON.stringify(object) === '{}') {
    return true;
  }
  const type = getType(object);
  if (type === '[object Array]' && object.length === 0) {
    return true;
  }
  if (type === '[object Object]' && Object.keys(object).length === 0) {
    return true;
  }
  if (type === '[object Set]' && object.size === 0) {
    return true;
  }
  return false;
};
export const isNoW = (object) => {
  return isNoE(object) || /^\s*$/gi.test(object);
};
export const isString = (object) => {
  return getType(object) === '[object String]';
};
export const isArray = (object) => {
  return getType(object) === '[object Array]';
};
export const isFn = (object) => {
  return getType(object) === '[object Function]';
};
export const padding = (object, fillLength = 2, char = '0', isEnd = false) => {
  if (isNull(object)) return null;
  const str = object.toString();
  const len = str.length;
  if (len >= fillLength) return str;
  const paddingValue = Math.pow(10, fillLength - len)
    .toString()
    .substr(1)
    .replace(/0/gi, char);
  const result = [paddingValue, str];
  if (isEnd) {
    result.reverse();
  }
  return result.join('');
};
export const ifNullOrEmpty = (value1, value2) => {
  return isNoE(value1) ? value2 : value1;
};
export const deepCopy = (dataSource) => {
  let copyData = Array.isArray(dataSource) ? [] : Object.create(null);
  if (dataSource && typeof dataSource === 'object') {
    for (let key in dataSource) {
      if (Object.prototype.hasOwnProperty.call(dataSource, key)) {
        if (dataSource[key] && typeof dataSource[key] === 'object') {
          copyData[key] = deepCopy(dataSource[key]);
        } else {
          copyData[key] = dataSource[key];
        }
      }
    }
  } else {
    copyData = dataSource;
  }
  return copyData;
};
export const toCamelObject = (obj) => {
  const type = getType(obj);
  if (obj === null || type !== '[object Object]') return null;
  const result = Object.create(null);
  const keys = Object.keys(obj);
  for (let key of keys) {
    result[camelCase(key)] = obj[key];
  }
  return result;
};
export const getPossibleData = (key, ...objects) => {
  let result = null;
  for (let obj of objects) {
    if (getType(obj) !== '[object Object]' || isNoE(obj[key])) continue;
    result = obj[key];
  }
  return result;
};

/**
 * 深度比较两个对象或数组是否相等
 * @param {*} obj1 第一个对象
 * @param {*} obj2 第二个对象
 * @returns {boolean} 是否相等
 */
export const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;

  if (obj1 == null || obj2 == null) return obj1 === obj2;

  if (typeof obj1 !== typeof obj2) return false;

  if (typeof obj1 !== 'object') return obj1 === obj2;

  if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;

  if (Array.isArray(obj1)) {
    if (obj1.length !== obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!deepEqual(obj1[i], obj2[i])) return false;
    }
    return true;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key)) return false;
    if (!deepEqual(obj1[key], obj2[key])) return false;
  }

  return true;
};
